module.exports = __webpack_public_path__ + "assets/LV.113b330c4f8a78a70c620f2facf56ab7.png";